export const handleKeyboardEvent = (event, key) => {
  if (event.key === key) return event.target.value
  return null
}
